module.exports = __webpack_public_path__ + "static/media/folder_gray.fa6ebea6.svg";